module.exports = __webpack_public_path__ + "static/img/img11-1-1.4e6d01d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img11-1-1.png
// module id = FnEF
// module chunks = 0